import { PayloadAction } from '@reduxjs/toolkit';

export enum PayCurrency {
  BTC = 'BTC',
  TON = 'TON',
  ETH = 'ETH',
  USDT = 'USDT',
  USDC = 'USDC',
  BUSD = 'BUSD',
}

export enum PayMethod {
  ONLYPAY = 'onlypay',
  BALANCE = 'BALANCE',
  CARD = 'CARD',
  CRYPTOPAY = 'CRYPTOPAY',
  TONKEEPER = 'TONKEEPER',
}

export enum PayProvider {
  inwizo = 'inwizo',
  singularity = 'singularity', // depricated (not active)
  pgn = 'pgn',
  m3 = 'm3', // depricated (not active)
  onePayment = '1payment', // (not active)
  only = 'only',
  plategaio = 'plategaio',
  settlepay = 'settlepay',
  settlepayWise = 'settlepayWise',
  numberx = 'numberx',
  tribute = 'tribute',
  payitnow24 = 'payitnow24', // depricated (not active)
  highhelp = 'highhelp',
  hodler = 'hodler',
  payball = 'payball',
}

export enum PaymentMethodOption {
  PIX = 'pix_brl',
  BOLETO = 'boleto_brl',
  SPEI = 'spei_mxn',
  OXXO = 'oxxopay_mxn',
  CARD_ACQUIRING = 'card_acquiring_rub',
  SBP = 'sbp',
  CARD = 'card',
  PAYPAL = 'paypal',
  APPLE_PAY = 'apple_pay',
  GOOGLE_PAY = 'google_pay',
}

export type PaymentProviderConfig =
  | {
      provider: PayProvider.m3;
      countryCode: string;
      paymentMethod:
        | PaymentMethodOption.CARD_ACQUIRING
        | PaymentMethodOption.SPEI
        | PaymentMethodOption.OXXO
        | PaymentMethodOption.PIX
        | PaymentMethodOption.BOLETO;
    }
  | {
      provider: PayProvider.inwizo;
      countryCode: string;
      paymentMethod: PaymentMethodOption.CARD_ACQUIRING | PaymentMethodOption.SBP;
    }
  | {
      provider: PayProvider.onePayment;
      countryCode: string;
      paymentMethod: PaymentMethodOption.CARD | PaymentMethodOption.SBP;
    }
  | {
      provider: PayProvider.only;
      countryCode: string;
      paymentMethod: PaymentMethodOption.SBP;
    }
  | {
      provider: PayProvider.plategaio;
      countryCode: string;
      paymentMethod: PaymentMethodOption.SBP;
    }
  | {
      provider: PayProvider.singularity;
      countryCode: string;
      paymentMethod: PaymentMethodOption.CARD;
    }
  | {
      provider: PayProvider.settlepayWise;
      countryCode: string;
      paymentMethod: PaymentMethodOption.CARD;
    }
  | {
      provider: PayProvider.pgn;
      countryCode: string;
      paymentMethod: PaymentMethodOption.CARD;
    }
  | {
      provider: PayProvider.tribute;
      countryCode: string;
      paymentMethod: PaymentMethodOption.CARD;
    }
  | {
      provider: PayProvider.payitnow24;
      countryCode: string;
      paymentMethod: PaymentMethodOption.CARD | PaymentMethodOption.PAYPAL;
    }
  | {
      provider: PayProvider.highhelp;
      countryCode: string;
      paymentMethod: PaymentMethodOption.SBP | PaymentMethodOption.CARD_ACQUIRING;
    }
  | {
      provider: PayProvider.hodler;
      countryCode: string;
      paymentMethod: PaymentMethodOption.SBP | PaymentMethodOption.CARD_ACQUIRING;
    }
  | {
      provider: PayProvider.payball;
      countryCode: string;
      paymentMethod:
        | PaymentMethodOption.CARD
        | PaymentMethodOption.APPLE_PAY
        | PaymentMethodOption.GOOGLE_PAY;
    };

export interface TopUpMethod {
  method: string;
  region: string;
  recommended: boolean;
  minAmount: number;
  maxAmount: number;
}

export interface PayState {
  isActive: boolean;
  title: string;
  description: string;
  amount: number;
  payUrl: string;
  payConfirmUrl: string;
  isWaitingForPay: boolean;
  invoiceId: number | null;
  randomInvoiceId: number | null;
  invoiceToken: string | null;
  isFailed: boolean;
  errorCode: string | null;
  availableCurrencies: PayCurrency[];
  availableMethods: PayMethod[];
  loadingRates: boolean;
  rates: {
    [key: string]: number;
  };
  topUpMethods: TopUpMethod[];
  topUpMethodsLoading: boolean;
  // currency: PayCurrency | null;
}

export type SetRatesAction = PayloadAction<{ [rate: string]: number }>;
export type SetCryptoPayUrlAction = PayloadAction<string | null>;
export type CryptoPayTopUpAction = PayloadAction<{
  currency: PayCurrency;
  amount: number;
}>;

export type ChooseMethodAction = PayloadAction<{
  method: PayMethod;
  options?: {
    skipAutoPay?: boolean;
    currency?: PayCurrency;
  };
}>;
export type SetAmountAction = PayloadAction<number>;
export type SetAvailableMethodsAction = PayloadAction<PayMethod[]>;
export type ShowAction = PayloadAction<{
  title?: string;
  description?: string;
}>;
